module.exports = __webpack_public_path__ + "07_face.bc824a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/07_face.png
// module id = OND2
// module chunks = 0